import React from 'react';
import { IOrderInfoDetails } from '@adac-mp/shared';
import { renderProductIcon } from '../../utils';
import {
	ProductOrderSummary,
	VignetteOrderSummary,
	TollSectionOrderSummary,
	FlexServiceOrderSummary,
} from '../../index';

interface IProductOrderSummaryContainerProps {
	orderItem: IOrderInfoDetails;
	index: number;
	hasCategories?: boolean;
	hasFuelType?: boolean;
	memberNo?: string;
}

export const ProductOrderSummaryContainer = ({ orderItem, index }: IProductOrderSummaryContainerProps) => {
	const { supplierId, moduleTypeId, tollClass } = orderItem;
	const productIcon = renderProductIcon({
		supplierId,
		moduleTypeId,
		tollClass,
	});

	const getCorrespondingProductSummaryElement = (id: number) => {
		switch (id) {
			case 2:
				return <VignetteOrderSummary currOrderItem={orderItem} />;
			case 3:
				return <TollSectionOrderSummary currOrderItem={orderItem} />;
			case 4:
				return <FlexServiceOrderSummary currOrderItem={orderItem} />;
			default:
				return null;
		}
	};

	return (
		<>
			<ProductOrderSummary
				key={`${orderItem.serviceCatalogId}-${index}`}
				order={orderItem}
				icon={productIcon}
				title={orderItem?.serviceCatalogName}
				category={
					orderItem
						? {
								moduleDetail: orderItem.moduleDetail,
								moduleDetailId: orderItem.moduleDetailId,
						  }
						: undefined
				}>
				{getCorrespondingProductSummaryElement(moduleTypeId)}
			</ProductOrderSummary>
		</>
	);
};
